import React, { useContext } from 'react';
import { CheckCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Flex, Tag } from 'antd';

import UbiquitiSiteContext from '@totem/components/ubiquiti/sites/ubiquitiSiteContainerContext';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

import {
  getActiveWans,
  getInstalledApps,
  groupDevicesBySite,
} from '../utilities';

import './ubiquitiSites.css';

const capitalize = (value: string) =>
  value.length === 0 ? value : value.charAt(0).toUpperCase() + value.slice(1);

const UbiquitiSitesCards = () => {
  const { siteData } = useContext(UbiquitiSiteContext);

  const getGroups = () => {
    if (siteData !== null && siteData.devices !== null) {
      return groupDevicesBySite(siteData.devices);
    }
    return [];
  };

  return (
    <div styleName="site-grid">
      {getGroups().map((group) => {
        const isConnected = group.host.reportedState.state === 'connected';
        const { counts } = group.site.statistics;

        return (
          <IBCard
            key={group.site.siteId}
            size="small"
            title={
              <Flex vertical justify="flex-start" align="start">
                <Flex justify="space-between" align="center">
                  <div>{group.host.reportedState.name}</div>
                  <Tag color={group.site.isOwner ? 'gold' : 'blue'}>
                    {group.site.isOwner
                      ? 'Owner'
                      : capitalize(group.site.permission)}
                  </Tag>
                </Flex>
                <div>{group.site.meta.desc}</div>
              </Flex>
            }
          >
            <div styleName="site-status-row">
              {isConnected ? (
                <CheckCircleOutlined style={{ color: 'green' }} />
              ) : (
                <MinusCircleOutlined />
              )}
              <span>{group.host.reportedState.hardware.name}</span>
            </div>
            {getActiveWans(group.site).map((wan) => (
              <div
                key={`${group.site.siteId}-${wan.externalIp}`}
                styleName="site-isp-row"
              >
                <span>{wan.ispInfo.name}</span>
                <Tag color={wan.wanUptime >= 100 ? 'green' : 'orange'}>
                  {wan.wanUptime.toFixed(2)}% uptime
                </Tag>
              </div>
            ))}
            <div styleName="site-stats-row">
              {counts.totalDevice} device{counts.totalDevice === 1 ? '' : 's'}
              {' · '}
              {counts.wiredClient} wired · {counts.wifiClient} wifi
              {counts.offlineDevice > 0 && (
                <>
                  {' · '}
                  <Tag color="red">{counts.offlineDevice} offline</Tag>
                </>
              )}
              {counts.criticalNotification > 0 && (
                <>
                  {' '}
                  <Tag color="red">{counts.criticalNotification} critical</Tag>
                </>
              )}
            </div>
            <div styleName="site-apps-row">
              {getInstalledApps(group.host).map((app) => (
                <Tag key={app}>{capitalize(app)}</Tag>
              ))}
            </div>
          </IBCard>
        );
      })}
    </div>
  );
};

export default UbiquitiSitesCards;
